export var Spacing = /*#__PURE__*/ function(Spacing) {
    /** 4px */ Spacing["3Xs"] = "0.25rem";
    /** 8px */ Spacing["Xxs"] = "0.5rem";
    /** 16px */ Spacing["Xs"] = "1rem";
    /** 24px */ Spacing["S"] = "1.5rem";
    /** 32px */ Spacing["M"] = "2rem";
    /** 48px */ Spacing["L"] = "3rem";
    /** 64px */ Spacing["Xl"] = "4rem";
    /** 96px */ Spacing["Xxl"] = "6rem";
    /** 128px */ Spacing["3Xl"] = "8rem";
    return Spacing;
}({});

//# sourceMappingURL=spacing.js.map